import { render, staticRenderFns } from "./HeaderDropdown.vue?vue&type=template&id=0881f392&scoped=true"
import script from "./HeaderDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./HeaderDropdown.vue?vue&type=style&index=0&id=0881f392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881f392",
  null
  
)

export default component.exports